// extracted by mini-css-extract-plugin
module.exports = {"aboutUsContainer":"AboutUs_aboutUsContainer__3qV8E","separator":"AboutUs_separator__8aqYS","downSeparator":"AboutUs_downSeparator__3XEHU"};